/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfPendingFileResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfPendingFileResponse } from '../../models/index.js';
// @ts-ignore
import { type WithFileItemRequestBuilder, WithFileItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/pending
 */
export interface PendingRequestBuilder extends BaseRequestBuilder<PendingRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.files.pending.item collection
     * @param fileId Unique identifier of the item
     * @returns {WithFileItemRequestBuilder}
     */
     byFileId(fileId: Guid) : WithFileItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfPendingFileResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<PendingRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfPendingFileResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PendingRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface PendingRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const PendingRequestBuilderUriTemplate = "{+baseurl}/files/pending{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PendingRequestBuilderNavigationMetadata: Record<Exclude<keyof PendingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFileId: {
        navigationMetadata: WithFileItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["fileId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PendingRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PendingRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfPendingFileResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
